// Pure helpers for TransactionDialog (extracted for readability; no behavior change).

export const EMPTY_TXN = {
    transaction_type: "BUY", sub_portfolio: "", ticker: "",
    quantity: "", price: "", fees: "0", tax_withheld: "0", amount: "",
    transaction_date: new Date().toISOString().slice(0, 10), notes: "",
};

export function txnFlags(type) {
    return {
        isCash: ["DEPOSIT", "WITHDRAWAL"].includes(type),
        isDiv: type === "DIVIDEND",
        subEnabled: ["BUY", "SELL", "DIVIDEND"].includes(type),
        tickerEnabled: ["BUY", "SELL", "DIVIDEND"].includes(type),
        feesEnabled: type === "BUY" || type === "SELL",
    };
}

export function buildInitialForm(editing, subs) {
    if (!editing) return { ...EMPTY_TXN, sub_portfolio: subs[0]?.name || "" };
    const isCash = ["DEPOSIT", "WITHDRAWAL"].includes(editing.transaction_type);
    const isDiv = editing.transaction_type === "DIVIDEND";
    return {
        transaction_type: editing.transaction_type,
        sub_portfolio: editing.sub_portfolio || "",
        ticker: editing.ticker || "",
        quantity: isCash ? "" : String(editing.quantity),
        price: isCash ? "" : String(editing.price),
        fees: isDiv ? "0" : String(editing.fees ?? 0),
        tax_withheld: isDiv ? String(editing.tax_withheld ?? 0) : "0",
        amount: isCash ? String(editing.price) : "",
        transaction_date: (editing.transaction_date || "").slice(0, 10),
        notes: editing.notes || "",
    };
}

export function computeNet(form) {
    return (parseFloat(form.quantity || 0) * parseFloat(form.price || 0)) - parseFloat(form.tax_withheld || 0);
}

// Returns an error message string, or null when valid.
export function validateTxn(form) {
    const { isCash, subEnabled, tickerEnabled } = txnFlags(form.transaction_type);
    if (subEnabled && !form.sub_portfolio) return "Select a sub-portfolio";
    if (tickerEnabled && !form.ticker) return "Ticker is required";
    if (!isCash && !parseFloat(form.quantity || 0)) return "Quantity is required";
    if (isCash && !parseFloat(form.amount || 0)) return "Amount is required";
    if (form.transaction_date && form.transaction_date > new Date().toISOString().slice(0, 10))
        return "Transaction date cannot be in the future";
    return null;
}

export function buildTxnPayload(form) {
    const type = form.transaction_type;
    const { isCash, isDiv, subEnabled } = txnFlags(type);
    return {
        transaction_type: type,
        sub_portfolio: subEnabled ? form.sub_portfolio : "",
        ticker: isCash ? null : form.ticker.toUpperCase(),
        quantity: isCash ? 1 : parseFloat(form.quantity || 0),
        price: isCash ? parseFloat(form.amount || 0) : parseFloat(form.price || 0),
        fees: (isCash || isDiv) ? 0 : parseFloat(form.fees || 0),
        tax_withheld: isDiv ? parseFloat(form.tax_withheld || 0) : 0,
        transaction_date: form.transaction_date,
        notes: form.notes,
    };
}
